function formateAsPercent(num: any) {
  return new Intl.NumberFormat("default", {
    style: "percent",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(num / 100);
}

function formateDataPrec(p: any) {
  return p.value >= 0 ? (
    <>{p.value === null ? "NA" : formateAsPercent(p.value)}</>
  ) : (
    <>
      <span className="text-danger">
        {"(" + formateAsPercent(p.value).slice(1) + ")"}
      </span>
    </>
  );
}
function currencyFormat(num: any) {
  return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

function formateDataCurr(p: any) {
  return p.value >= 0 ? (
    <>{p.value === null ? "NA" : "$" + currencyFormat(p.value)}</>
  ) : (
    <>
      <span className="text-danger">
        {"(" + "$" + currencyFormat(p.value).slice(1) + ")"}
      </span>
    </>
  );
}
function formateDatabuyCurr(p: any) {
  return p.value >= 0 ? (
    <>
      {p.value === null ? (
        "NA"
      ) : (
        <span className="text-success ">{"$" + currencyFormat(p.value)}</span>
      )}
    </>
  ) : (
    <>
      <span className="text-danger">
        {"(" + "$" + currencyFormat(p.value).slice(1) + ")"}
      </span>
    </>
  );
}


const PortfolioColumnDefs = [
  {
    field: "perfDate",
    headerName: "Date",
    width: 110,
    cellClass: "cell-wrap-text",
    floatingFilter: true,
    filter: "agDateColumnFilter",
    flex: 1,
    cellRenderer: (p: any) => {
      return new Date(p.value).toLocaleDateString();
    },
  },
  {
    field: "mtdGross",
    headerName: "MTD",

    cellRenderer: formateDataPrec,
    width: 100,
    cellClass: "cell-wrap-text",
  },
  {
    field: "qtdGross",
    headerName: "QTD",

    cellRenderer: formateDataPrec,
    width: 100,
    cellClass: "cell-wrap-text",
  },
  {
    field: "threeMonthsGross",
    headerName: "3M",

    cellRenderer: formateDataPrec,
    width: 100,
    cellClass: "cell-wrap-text",
  },
  {
    field: "oneYearGross",
    headerName: "YTD",

    cellRenderer: formateDataPrec,
    width: 100,
    cellClass: "cell-wrap-text",
  },
  {
    field: "oneYearGross",
    headerName: "1Y",

    width: 100,
    cellRenderer: formateDataPrec,
    cellClass: "cell-wrap-text",
  },
  {
    field: "threeYearGross",
    headerName: "3Y",

    cellRenderer: formateDataPrec,
    width: 100,
    cellClass: "cell-wrap-text",
  },
  {
    field: "fiveYearGross",
    headerName: "5Y",

    cellRenderer: formateDataPrec,
    width: 100,
    cellClass: "cell-wrap-text",
  },
  {
    field: "sevenYearGross",
    headerName: "7Y",

    cellRenderer: formateDataPrec,
    width: 100,
    cellClass: "cell-wrap-text",
  },
  {
    field: "tenYearGross",
    headerName: "10Y",

    cellRenderer: formateDataPrec,
    width: 100,
    cellClass: "cell-wrap-text",
  },
  {
    field: "sinceInceptionGross",
    headerName: "Since Inception",
    width: 100,
    cellStyle: { "white-space": "normal" },
    autoHeight: true,
    cellRenderer: formateDataPrec,
    cellClass: "cell-wrap-text",
  },
];

const SectorColumnDefs = [
  {
    field: "sectorName",
    headerName: "Sector",
    width: 210,
    resizable: true,
    cellClass: "cell-wrap-text",
    flex: 1,
    floatingFilter: true,
    filter: "agTextColumnFilter",

  },
  {
    field: "perfDate",
    headerName: "Date",
    width: 80,
    cellClass: "cell-wrap-text",
    filter: "agDateColumnFilter",
    floatingFilter: true,
    cellRenderer: (p: any) => {
      return new Date(p.value).toLocaleDateString();
    },
  },
  {
    field: "mtdGross",
    headerName: "MTD",
    cellRenderer: formateDataPrec,
    width: 80,
    cellClass: "cell-wrap-text",
  },
  {
    field: "qtdGross",
    headerName: "QTD",
    cellRenderer: formateDataPrec,
    width: 80,
    cellClass: "cell-wrap-text",
  },
  {
    field: "threeMonthsGross",
    headerName: "3M",
    cellRenderer: formateDataPrec,
    width: 80,
    cellClass: "cell-wrap-text",
  },
  {
    field: "oneYearGross",
    headerName: "YTD",
    cellRenderer: formateDataPrec,
    width: 80,
    cellClass: "cell-wrap-text",
  },
  {
    field: "oneYearGross",
    headerName: "1Y",
    width: 80,
    cellRenderer: formateDataPrec,
    cellClass: "cell-wrap-text",
  },
  {
    field: "threeYearGross",
    headerName: "3Y",
    cellRenderer: formateDataPrec,
    width: 80,
    cellClass: "cell-wrap-text",
  },
  {
    field: "fiveYearGross",
    headerName: "5Y",
    cellRenderer: formateDataPrec,
    width: 80,
    cellClass: "cell-wrap-text",
  },
  {
    field: "sevenYearGross",
    headerName: "7Y",
    cellRenderer: formateDataPrec,
    width: 80,
    cellClass: "cell-wrap-text",
  },
  {
    field: "tenYearGross",
    headerName: "10Y",
    cellRenderer: formateDataPrec,
    width: 80,
    cellClass: "cell-wrap-text",
  },
  {
    field: "sinceInceptionGross",
    headerName: "Since Inception",
    width: 80,
    cellRenderer: formateDataPrec,
    cellClass: "cell-wrap-text",
  },
];

const HistoricalColumnDefs = [
  {
    field: "clientName",
    headerName: "Client Name",
    width: 140,
    resizable: true,
    cellClass: "cell-wrap-text",
    flex: 1,
    floatingFilter: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "year",
    headerName: "Year",
    width: 120,
    cellClass: "cell-wrap-text",
    filter: "agDateColumnFilter",
    floatingFilter: true,
  },
  {
    field: "jan",
    headerName: "Jan",
    cellRenderer: formateDataPrec,
    width: 70,
    cellClass: "cell-wrap-text",
  },
  {
    field: "feb",
    headerName: "Feb",
    cellRenderer: formateDataPrec,
    width: 70,
    cellClass: "cell-wrap-text",
  },
  {
    field: "mar",
    headerName: "Mar",
    cellRenderer: formateDataPrec,
    width: 70,
    cellClass: "cell-wrap-text",
  },
  {
    field: "april",
    headerName: "April",
    cellRenderer: formateDataPrec,
    width: 70,
    cellClass: "cell-wrap-text",
  },
  {
    field: "may",
    headerName: "May",
    width: 70,
    cellRenderer: formateDataPrec,
    cellClass: "cell-wrap-text",
  },
  {
    field: "june",
    headerName: "June",
    cellRenderer: formateDataPrec,
    width: 70,
    cellClass: "cell-wrap-text",
  },
  {
    field: "july",
    headerName: "July",
    cellRenderer: formateDataPrec,
    width: 70,
    cellClass: "cell-wrap-text",
  },
  {
    field: "aug",
    headerName: "Aug",
    cellRenderer: formateDataPrec,
    width: 70,
    cellClass: "cell-wrap-text",
  },
  {
    field: "sept",
    headerName: "Sept",
    cellRenderer: formateDataPrec,
    width: 70,
    cellClass: "cell-wrap-text",
  },
  {
    field: "oct",
    headerName: "Oct",
    width: 70,
    cellRenderer: formateDataPrec,
    cellClass: "cell-wrap-text",
  },
  {
    field: "nov",
    headerName: "Nov",
    width: 70,
    cellRenderer: formateDataPrec,
    cellClass: "cell-wrap-text",
  },
  {
    field: "dec",
    headerName: "Dec",
    width: 70,
    cellRenderer: formateDataPrec,
    cellClass: "cell-wrap-text",
  },
  {
    field: "ytd",
    headerName: "YTD",
    width: 70,
    cellRenderer: formateDataPrec,
    cellClass: "cell-wrap-text",
  },
];

const SectorActivityColumnDefs = [
  {
    field: "sectorName",
    headerName: "Sector Name",
    width: 250,
    resizable: true,
    cellClass: "cell-wrap-text",
    flex: 1,
  },
  {
    field: "marketValue",
    headerName: "Market Value",
    width: 140,
    cellClass: "cell-wrap-text textAlign",
    cellRenderer: formateDataCurr,
    headerClass: "headerTextAlign",
  },
  {
    field: "buy",
    headerName: "Buy",
    cellRenderer: formateDatabuyCurr,
    width: 150,
    cellClass: "cell-wrap-text textAlign",
    headerClass: "headerTextAlign",
  },
  {
    field: "sell",
    headerName: "Sell",
    cellRenderer: formateDataCurr,
    width: 150,
    cellClass: "cell-wrap-text textAlign",
    headerClass: "headerTextAlign",
  },
  {
    field: "sectorGainLoss",
    headerName: "Gain/Loss",
    cellRenderer: formateDataCurr,
    width: 150,
    cellClass: "cell-wrap-text textAlign",
    headerClass: "headerTextAlign",
  },
  {
    field: "sectorPerf",
    headerName: "Sector Perf",
    cellRenderer: formateDataPrec,
    width: 140,
    cellClass: "cell-wrap-text",
  },
  {
    field: "sectorBenchmark",
    headerName: "Benchmark",
    width: 140,
    cellRenderer: formateDataPrec,
    cellClass: "cell-wrap-text",
  },
];
const TransationColumnDefs = [
  {
    field: "symbol",
    headerName: "Symbol",
    width: 250,
    resizable: true,
    cellClass: "cell-wrap-text",
    flex: 1,
    floatingFilter: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "transactionDate",
    headerName: "Date",
    width: 120,
    cellClass: "cell-wrap-text",
    filter: "agDateColumnFilter",
    floatingFilter: true,
    cellRenderer: (p: any) => {
      return new Date(p.value).toLocaleDateString();
    },
  },
  {
    field: "transactionCode",
    headerName: "Transaction Code",
    width: 110,
    cellClass: "cell-wrap-text",
    //cellRenderer: formateDataCurr,
    //headerClass: "headerTextAlign",
    floatingFilter: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "amount",
    headerName: "Amount",
    cellRenderer: formateDatabuyCurr,
    width: 120,
    cellClass: "cell-wrap-text textAlign",
    headerClass: "headerTextAlign",
  },
  {
    field: "quantity",
    headerName: "Quantity",
    //cellRenderer: formateDataCurr,
    width: 120,
    cellClass: "cell-wrap-text textAlign",
    headerClass: "headerTextAlign",
  },
  {
    field: "price",
    headerName: "Price",
    cellRenderer: formateDataCurr,
    width: 150,
    cellClass: "cell-wrap-text textAlign px-2",
    headerClass: "headerTextAlign",
  },
  {
    field: "notes",
    headerName: "Notes",
    //cellRenderer: formateDataPrec,
    width: 250,
    cellClass: "cell-wrap-text",
  },
];

const SectorAllocationTblComumns = [
  {
    field: "sectorName",
    headerName: "Sector Name",
    width: 220,
    resizable: true,
    cellClass: "cell-wrap-text",
    flex: 1,
  },

  {
    field: "balanceBySector",
    headerName: "Balance By Sector",
    width: 130,
    cellClass: "cell-wrap-text",
    cellRenderer: formateDataCurr,
    //headerClass: "headerTextAlign",
  },
  {
    field: "sectorHoldingsPct",
    headerName: "Sector Holdings Pct",
    cellRenderer: formateDataPrec,
    width: 80,
    cellClass: "cell-wrap-text textAlign",
    headerClass: "headerTextAlign",
  },
];
const SectorAllocationTblRightColumns = [
  {
    field: "symbol",
    headerName: "Symbol",
    width: 100,

    cellClass: "cell-wrap-text",
    flex: 1,
  },

  {
    field: "qty",
    headerName: "Qty",
    width: 80,
    cellClass: "cell-wrap-text",
    //cellRenderer: formateDataCurr,
    //headerClass: "headerTextAlign",
  },
  {
    field: "price",
    headerName: "Price",
    cellRenderer: formateDataCurr,
    width: 100,
    cellClass: "cell-wrap-text textAlign",
    headerClass: "headerTextAlign",
  },
  {
    field: "marketValue",
    headerName: "Market Value",
    cellRenderer: formateDataCurr,
    width: 100,
    cellClass: "cell-wrap-text textAlign",
    headerClass: "headerTextAlign",
  },
  {
    field: "securityHoldingsPct",
    headerName: "Security Holdings Pct",
    cellRenderer: formateDataPrec,
    width: 100,
    cellClass: "cell-wrap-text textAlign",
    headerClass: "headerTextAlign",
  },
];
export {
  PortfolioColumnDefs,
  SectorColumnDefs,
  HistoricalColumnDefs,
  SectorActivityColumnDefs,
  TransationColumnDefs,
  SectorAllocationTblComumns,
  SectorAllocationTblRightColumns,
};
